import * as React from "react";
import styled from "styled-components";
import { RankingBarChart } from "./RankingBarChart";
import { roundDatum } from "../../../utils/numbers";

const ScrollContainer = styled.div`
  max-height: 500px;
  overflow-y: auto;
`;

interface Datum {
  name: string;
  value: number;
}

interface Props {
  data: Datum[];
  color: string;
  valueSuffix: string;
}

export const ZonesDiscomfortBarChart: React.FC<Props> = ({
  data,
  color,
  valueSuffix,
}) => {
  const formatTooltipValue = (value: number) =>
    `${roundDatum(value)}${valueSuffix}`;

  return (
    <ScrollContainer>
      <RankingBarChart
        data={data}
        color={color}
        tooltipFormatter={formatTooltipValue}
      />
    </ScrollContainer>
  );
};
